/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Realico Portal API
 * Portal API
 * OpenAPI spec version: 1.0.0
 */

/**
 * @nullable
 */
export type ListingDetailResponseDtoLandSubtype = typeof ListingDetailResponseDtoLandSubtype[keyof typeof ListingDetailResponseDtoLandSubtype] | null;


export const ListingDetailResponseDtoLandSubtype = {
  FAMILY_HOUSE_PLOT: 'FAMILY_HOUSE_PLOT',
  APARTMENT_DEVELOPMENT_PLOT: 'APARTMENT_DEVELOPMENT_PLOT',
  COMMERCIAL_DEVELOPMENT_PLOT: 'COMMERCIAL_DEVELOPMENT_PLOT',
  RECREATIONAL_GARDEN_PLOT: 'RECREATIONAL_GARDEN_PLOT',
  AGRICULTURAL_LAND: 'AGRICULTURAL_LAND',
  VINEYARD: 'VINEYARD',
  ORCHARD: 'ORCHARD',
  FOREST: 'FOREST',
} as const;
